module.exports = __webpack_public_path__ + "static/media/480.56ffd020.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-paint-bucket/light/480.png
// module id = 2306
// module chunks = 2